module.exports = __webpack_public_path__ + "static/media/teamspeak.147e5fa5.svg";